export { default } from "./Recommendations";
